import initForm from ".//initForm.js";

import axios from 'axios';

const initFormsSubmit = () => {

    console.log('form submit.js');

    const {initFormInputs, renderFormErrors} = initForm();
    initFormInputs();

    const dialogSuccessElm = document.getElementById('success__dialog');
    const dialogErrorElm = document.getElementById('error__dialog');

    const formElms = document.querySelectorAll('.form__block');

    if (formElms && formElms.length) {
        formElms.forEach(formElm => {
            const formSubmitBtn = formElm.querySelector('[data-form-submit]');
            const formItemElms = formElm.querySelectorAll('.form__item');
            // const dialogElm = formElm.closest('dialog');

            let debounceTimer = null;
            const DEBOUNCE_DELAY = 1000;

            const runSubmit = () => {
                formSubmitBtn?.classList.add('button--loading');

                handleFormSubmit().finally(() => {
                    formSubmitBtn?.classList.remove('button--loading');
                });
            };

            formElm.addEventListener('submit', (e) => {
                e.preventDefault();

                clearTimeout(debounceTimer);
                formSubmitBtn.classList.add('button--loading');
                debounceTimer = setTimeout(runSubmit, DEBOUNCE_DELAY);
            });

            async function handleFormSubmit() {
                const formData = new FormData(formElm);

                try {
                    const response = await axios.post(formElm.action, formData);
                    if (response && response.status === 200) {
                        const parentDialog = formElm.closest('dialog');
                        if (parentDialog) {
                            parentDialog.close();
                        }

                        setTimeout(() => {
                            if (response.data && response.data.message) {
                                if (response.data.success) {
                                    if(dialogSuccessElm) {
                                        dialogSuccessElm.querySelector('.dialog__response_title').textContent = response.data.message;
                                        dialogSuccessElm.showModal();
                                    }
                                } else {
                                    if (dialogErrorElm) {
                                        dialogErrorElm.querySelector('.dialog__response_title').textContent = response.data.message;
                                        dialogErrorElm.showModal();
                                    }
                                }
                            }

                            // console.log('Form submitted successfully', response);
                            formElm.reset();
                            formItemElms.forEach(item => item.classList.remove('has--value', 'has--error'));

                            formSubmitBtn?.classList.remove('button--loading');


                            if(formElm.dataset.form === 'jobs') {
                                const fileItem = formElm.querySelector('.form__upload_item');
                                const fileInput = fileItem.closest('.form__upload').querySelector('.form__upload_input');
                                fileItem.remove();
                                fileInput.value = '';
                            }

                        }, 60);
                    } else {
                        // console.warn('Unexpected response', response);
                        if (dialogErrorElm) {
                            dialogErrorElm.querySelector('.dialog__response_title').textContent = response.data.message;
                            dialogErrorElm.showModal();
                        }
                        formSubmitBtn?.classList.remove('button--loading');
                    }
                } catch (error) {
                    const status = error?.response?.status;
                    if (status === 422 && error.response?.data?.errors) {
                        renderFormErrors(error, formElm);
                    } else if (error?.response?.data?.message) {
                        document.querySelectorAll('dialog').forEach(d => { try { d.close(); } catch (e) { /* noop */ } });
                        if (dialogErrorElm) {
                            // const responseTitle = dialogErrorElm.querySelector('.dialog__response_title') || dialogErrorElm.querySelector('.dialog__title');
                            // if (responseTitle) responseTitle.textContent = error.response.data.message;
                            dialogErrorElm.querySelector('.dialog__response_title').textContent = response.data.message;
                            dialogErrorElm.showModal();
                        }
                    } else {
                        console.log('An unexpected error occurred');
                        if (dialogErrorElm) {
                            dialogErrorElm.querySelector('.dialog__response_title').textContent = response.data.message;
                            dialogErrorElm.showModal();
                        }
                    }
                    formSubmitBtn?.classList.remove('button--loading');
                }
            }
        });
    }

}

export default initFormsSubmit;
